'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Lib


// Components


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ArrowTool = require('./ArrowTool');

var _ArrowTool2 = _interopRequireDefault(_ArrowTool);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EndArrowTool = function EndArrowTool(props) {
    return _react2.default.createElement(_ArrowTool2.default, _extends({}, props, { styleProp: 'endStyle', iconDirection: 'right' }));
};

exports.default = EndArrowTool;


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/toolbar/selectionTools/arrowTools/EndArrowTool.js
// module id = 2225
// module chunks = 0